import { HttpMethod } from '../../types.js';
export const ApiDef_AppConfig = {
    _v1: {
        getConfigByKey: { method: HttpMethod.GET, path: 'v1/app-config/get-resolver-data-by-key' },
    }
};
//# sourceMappingURL=api-def.js.map